module.exports = __webpack_public_path__ + "img/231.2b912528.jpg";